import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.478 5.738a3.6 3.6 0 0 0-4.964.008c-1.356 1.277-1.325 3.498.032 4.94 1.277 1.356 3.498 1.325 4.94-.032 1.374-1.293 1.4-3.499-.008-4.916M8.486 4.654a5.1 5.1 0 0 1 7.044.016c1.984 1.983 2.008 5.171-.016 7.076-1.957 1.843-5.136 2.012-7.06-.032-1.843-1.958-2.012-5.137.032-7.06M12 16.35c-2.807 0-5.426 1.301-6.288 3.887a.75.75 0 0 1-1.423-.474C5.427 16.349 8.808 14.85 12 14.85c3.185 0 6.587 1.496 7.619 4.935a.75.75 0 0 1-1.437.43c-.769-2.561-3.366-3.865-6.182-3.865",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }